import React, {useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import mainbg from 'images/mainbg.png';
import styled from 'styled-components';
import { Banner } from 'components';
import methods from '../data/methods';
import i18n from 'i18next';

const FilterDiv = styled.div`
	width: 100vw;
	padding: 40px;
	background-image: url(${mainbg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;
`;

const LayerColor = styled.div`
	height: 100%;
	width: 100%;
	position: absolute !important;
	top: 0;
	left: 0;
	background-color: rgba(3, 71, 129, 0.6);
	z-index: 20;
`;

const Title = styled.div`
	z-index: 100;
`;

const BuyerIntegration = () => {
	const { t } = useTranslation();

	useEffect(() => window.scrollTo(0, 0), []);

	return (
		<>
			<FilterDiv className='block-fullwidth padding-40'>
				<LayerColor />
				<Title className='color-white col-1 font-24 font-bold text-center text-uppercase'>{t('Интеграция с покупателями')}</Title>
			</FilterDiv>
			<Banner />

			<div className='pt-sans padding-20 font-16 color-grey'>
				{t('Сделав интеграцию с нами, ваши клиенты смогут бронировать наши отели на вашем сайте или приложении.')}
			</div>
			<div className='lightblue-container flex column align-center padding-20'>
				<div className='text-uppercase color-blue text-center font-bold font-20 margin-bottom-20'>{t('МЕТОДЫ')} API</div>
				<div className='divider col-1 margin-bottom-20' />
				<div className={classNames('item', 'col-1', 'margin-bottom-10', 'flex', 'row', 'justify-between')}>
					<div>
						<div className='color-blue font-16  font-bold margin-bottom-10'><NavLink to='/buyer_integration/between_systems' rel="noreferrer">{t('Способы отправки запросов')}</NavLink></div>
					</div>
				</div>
				<div className='divider col-1 margin-bottom-20' />
				<div className={classNames('item', 'col-1', 'margin-bottom-10', 'flex', 'row', 'justify-between')}>
					<div>
						<div className='color-blue font-16  font-bold margin-bottom-10'><NavLink to='https://images.acase.ru/sjas/xmlgw/xsd/Common.xsd' target="_blank" rel="noreferrer">{t('Схема общих элементов')}</NavLink></div>
						<div className='pt-sans color-grey font-16 margin-bottom-10'>{t('Общее для всех схем описание типов')}</div>
					</div>
				</div>
				<div className='divider col-1 margin-bottom-20' />
				{methods.map((j, key) =>
					<React.Fragment key={key}>
						<div className={classNames('item', 'col-1', {'margin-bottom-10': key + 1 < methods.length}, {'margin-bottom-20': key + 1 === methods.length}, 'flex', 'row', 'justify-between')} key={key}>
							<div>
								<div className='color-blue font-16  font-bold margin-bottom-10'>{!(j?.old === 2) ? <NavLink to={'/method/' + j.id}>{j.id}</NavLink> : j.id}  {j?.warning?.length > 0 && <span className='orange spaced'>{i18n.language === 'en'&& j?.warning_en?.length > 0 ? j?.warning_en : j?.warning}</span>}</div>
								<div className='pt-sans color-grey font-16 margin-bottom-10'>{i18n.language === 'en'&& j?.decription_en?.length > 0 ? j?.decription_en : j?.decription}</div>
							</div>
						</div>
						<div className='divider col-1 margin-bottom-20' />
					</React.Fragment>
				)}
			</div>
		</>
	);
};

export default BuyerIntegration;